import React from 'react';
import { useTranslation } from 'react-i18next';
import { useDispatch } from 'react-redux';
import { useApolloClient } from '@apollo/client';
import { FontAwesomeIcon } from '@fortawesome/react-fontawesome';
import ExpandedListTab from '../ExpandedListTab';
import ReadonlyField from '../fields/ReadonlyField';
import MutationButton from '../buttons/MutationButton';
import useExtendedQuery from '../../hooks/useExtendedQuery';
import {
    FAILOVER,
    SWITCH_APPLICATION_NODE,
} from '../../graphql/settings';
import Spinner from '../Spinner';
import Error from '../errors/Error';
import useExtendedMutation from '../../hooks/useExtendedMutation';
import { logoutUser } from '../../actions/authentication';

function FailoverDetailTab() {
    const { t } = useTranslation();
    const dispatch = useDispatch();
    const apolloClient = useApolloClient();
    const {
        loading,
        error,
        data,
    } = useExtendedQuery(FAILOVER);
    const switchApplicationNodeMutation = useExtendedMutation(SWITCH_APPLICATION_NODE, {
        successCallback: ({ switchApplicationNode: { nodeId } }) => {
            dispatch(logoutUser(t('settings.failover.logout', { nodeId }), t('settings.failover.logout-error'), apolloClient));
        },
        failureMessageOptions: { key: 'settings.failover.switch-application-node-failure' },
        withCorrelationId: false,
    });
    let result;
    if (loading) {
        result = <Spinner className="failover-loading" />;
    } else if (error) {
        result = <Error className="failover-error" error={error} />;
    } else {
        result = (
            <>
                <div className="rich-list-row-expanded--fields">
                    <ReadonlyField
                        label={t('settings.failover.node-id')}
                        value={data.failover.nodeId}
                        emptyValue={t('misc.na')}
                        className="failover-detail-tab--fields--node-id"
                    />
                    <ReadonlyField
                        label={t('settings.failover.ldap-node')}
                        value={data.failover.ldapNode}
                        emptyValue={t('misc.na')}
                        className="failover-detail-tab--fields--ldap-node"
                    />
                </div>
                <div className="rich-list-row-expanded--buttons">
                    <div className="rich-list-row-expanded--buttons--left">
                        <MutationButton
                            className="switch-application-node-button button-bordered button"
                            confirmationMessage={t('settings.failover.switch-application-node-confirmation-message')}
                            extendedMutation={switchApplicationNodeMutation}
                            showConfirmationDialog
                        >
                            <FontAwesomeIcon icon="exchange-alt" />&nbsp;{t('settings.failover.switch-application-node-button')}
                        </MutationButton>
                    </div>
                </div>
            </>
        );
    }
    return (
        <ExpandedListTab
            className="settings-detail-tab"
        >
            {result}
        </ExpandedListTab>
    );
}

export default FailoverDetailTab;
